import type { I18nPrefix } from '../../i18n/prefix';

export const I18N_PAGE =
  'features:configurations.pages.configurations_general_page' satisfies I18nPrefix;

const DOCS_BASE = 'https://docs.sparklayer.io';

export const DOCS_URLS = {
  companyUsers: `${DOCS_BASE}/company-users`,
  quoting: `${DOCS_BASE}/quoting`,
  quoteStatuses: `${DOCS_BASE}/quoting#T3MSw`,
  purchaseTimeline: `${DOCS_BASE}/timeline`,
  customEmailDomain: `${DOCS_BASE}/timeline#custom-from-email-address`,
  invoices: `${DOCS_BASE}/invoices`,
  multiLocationStock: `${DOCS_BASE}/customers#jyPsM`,
  paymentsVisibility: `${DOCS_BASE}/payment-methods#payments-visibility`,
  dashboardConfigurations: `${DOCS_BASE}/dashboard-configurations`,
  applyPriceBreaksAcrossVariants: `${DOCS_BASE}/dashboard-configurations#J5YMy`,
  cartSearchType: `${DOCS_BASE}/my-order-interface#FABUR`,
  hideAICartFeatures: `${DOCS_BASE}/intelligent-cart`,
} as const;

export const CART_SEARCH_TYPES = ['basic', 'full', 'off'] as const;
export type CartSearchType = (typeof CART_SEARCH_TYPES)[number];

export const HELP_PATH = '/help';

/** Intercom product tour for the "Watch Tour" action. */
export const PRODUCT_TOUR_ID = '305711';
